import { render, staticRenderFns } from "./ReleaseAnnouncement.vue?vue&type=template&id=2425da2c&scoped=true&"
import script from "./ReleaseAnnouncement.vue?vue&type=script&lang=js&"
export * from "./ReleaseAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseAnnouncement.vue?vue&type=style&index=0&id=2425da2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2425da2c",
  null
  
)

export default component.exports